import React from 'react';
import { cx } from './_cx';

/**
 * Stack (UI primitive)
 *
 * Layout helper to standardize spacing between elements without inline CSS
 * duplication. Uses CSS custom properties so spacing stays token-driven.
 */
export function Stack({
  as,
  direction = 'column', // column | row
  gap, // number (px) or string (any CSS length)
  align,
  justify,
  wrap,
  style,
  className,
  ...props
}) {
  const Component = as || 'div';
  const isRow = direction === 'row';
  const gapVarName = isRow ? '--pv-row-gap' : '--pv-stack-gap';
  const resolvedGap = typeof gap === 'number' ? `${gap}px` : gap;

  return (
    <Component
      className={cx(isRow ? 'pv-row' : 'pv-stack', className)}
      style={{
        ...(resolvedGap ? { [gapVarName]: resolvedGap } : null),
        ...(align ? { alignItems: align } : null),
        ...(justify ? { justifyContent: justify } : null),
        ...(wrap ? { flexWrap: wrap } : null),
        ...(style || null),
      }}
      {...props}
    />
  );
}

